import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do manufacturers attract B2B buyers online?",
    "a": "Capability-driven content — what you actually make, what tolerances, what materials, what volumes. Engineers and buyers search for capability matches. Sites that match capability win the RFQ."
  },
  {
    "q": "Is SEO worth it for manufacturing?",
    "a": "Yes — B2B buyers research extensively before they call. SEO captures the entire RFQ research window. One signed contract often covers years of marketing investment."
  },
  {
    "q": "Should manufacturers run Google Ads?",
    "a": "Yes — RFQ-stage keywords are stable and lower-competition than B2C. We build campaigns tuned to capability matches with engineer-focused landing pages."
  },
  {
    "q": "What about ISO, AS9100, and other certifications?",
    "a": "Critical content — certifications signal capability and pass procurement screens. We feature certifications prominently and build them into capability pages."
  },
  {
    "q": "Do you market specialty manufacturing (medical, aerospace, defense)?",
    "a": "Yes — regulated and specialty manufacturing each have their own search ecosystems with lower competition and higher contract values."
  }
];

export const Route = createFileRoute("/manufacturing-marketing-colorado")({
  head: () =>
    industryMarketingHead("Manufacturing", "manufacturing company", "manufacturing-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Manufacturing"}
      industryLower={"manufacturing company"}
      slug={"manufacturing-marketing-colorado"}
      subheadline={"We help Colorado manufacturers — contract, custom, and OEM — build a steady B2B inbound pipeline from real buyers, not tire-kickers."}
      painPoints={["Trade shows are expensive and your booth traffic doesn't convert","Your site reads brochure — it doesn't pre-qualify or convert engineers","Buyers can't find you in search for what you actually make"]}
      serviceDescriptions={{
        seo: "Rank for contract manufacturing, CNC machining, fabrication, custom manufacturing, and every capability across every Colorado market.",
        googleMaps: "Own 'manufacturer near me' in B2B Map Pack with capability and certification signals.",
        webDesign: "Capability-driven sites with engineering content, project case studies, and RFQ workflows tuned to engineers and buyers.",
        ppc: "Profitable Google Ads tuned to RFQ-stage searches with engineer-focused landing pages.",
        geoAi: "Get cited when buyers ask ChatGPT 'best contract manufacturer in Colorado' or 'CNC shop near me'.",
        socialMedia: "Capability and project content that builds trust with engineers and procurement teams.",
      }}
      testimonial={{"quote":"RFQ volume from search alone is now larger than what we used to get from trade shows. The capability pages do the engineering pre-sale.","role":"Contract Manufacturing CEO","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Manufacturing marketing in Colorado Springs","description":"Defense, aerospace, and contract manufacturing across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Manufacturing marketing in Denver","description":"Industrial and contract manufacturing across the Denver metro."},{"to":"/boulder-digital-marketing","label":"Manufacturing marketing in Boulder","description":"Tech, biotech, and precision manufacturing across Boulder County."}]}
    />
  ),
});
